var React = require('react');

function StrapiOmg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#8E75FF","fillRule":"evenodd","d":"M25.979 4.727H8.751v8.638h8.477c.302 0 .547.245.547.547v8.36h8.751V5.275a.547.547 0 00-.547-.548z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"#8E75FF","fillRule":"evenodd","d":"M8.75 4.727v8.638H.668a.274.274 0 01-.192-.469L8.75 4.727zm9.491 25.723a.274.274 0 01-.466-.195v-7.983h8.751l-8.285 8.177z","clipRule":"evenodd","opacity":".405","key":1}),React.createElement("path",{"fill":"#8E75FF","d":"M8.75 13.365h8.752c.15 0 .273.122.273.273v8.634H9.298a.547.547 0 01-.547-.547v-8.36z","opacity":".405","key":2})]);
}

StrapiOmg.defaultProps = {"fill":"none","viewBox":"0 0 28 31"};

module.exports = StrapiOmg;

StrapiOmg.default = StrapiOmg;
